import History from '../../../components/Common/History'
import EnquiriesForm from '../../../components/Sales/Enquiries/EnquiriesForm'
import Files from '../../../components/Sales/Enquiries/Files'
import Folders from '../../../components/Sales/Enquiries/Folders'
import EnquiriesLinesCont from '../../../components/Sales/Enquiries/Lines/EnquiriesLinesCont'
import React from 'react'
import { Modal, Row, Tabs } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import Documents from '../../../components/Common/Documents/DocumentsCont'

const { TabPane } = Tabs

function EnquiriesModal(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    enquiry,
    fetching,
  } = props

  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Enquiries'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Department'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'85%'}>
      <Tabs defaultActiveKey="details">
        <TabPane tab="Details" key="details">
]         <EnquiriesForm ref={formRef} {...props} />
        </TabPane>
        <TabPane disabled={modalType !== 'edit'} tab={'Lines'} key="#lines">
          <EnquiriesLinesCont enquiry={enquiry} />
        </TabPane>

        <TabPane disabled={isNew} tab="Files" key="files">
          <Documents editable={true} footer={false} category={false} owner={enquiry} />
        </TabPane>
        <TabPane disabled={modalType !== 'edit'} tab={'History'} key="#history">
          <History loading={fetching} owner={enquiry} />
        </TabPane>
        <TabPane disabled={modalType !== 'edit'} tab={'Transmittal'} key="#transmittal">
          <Tabs defaultActiveKey="folders" tabPosition="left">
            <TabPane tab="Folders" key="folders">
              <Folders enquiry={enquiry} />
            </TabPane>
            <TabPane tab="Files" key="files">
              <Files enquiry={enquiry} />
            </TabPane>
          </Tabs>
        </TabPane>
      </Tabs>
    </Modal>
  )
}

EnquiriesModal.propTypes = {}
EnquiriesModal.defaultProps = {}

export default EnquiriesModal
